import { Modal, notification } from "antd";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../Services/axiosCommon";
import { useFormik } from "formik";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import * as yup from "yup";
import {
  NuDate,
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import DropDownAddMetaData from "../../../../Components/Utils/selectAddMetaData";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { useToast } from "../../../../Components/Others/ToastServices";

const CreateEmailSent = ({
  open,
  getData,
  onCancel,
  data,
  projectList,
  firstProject,
}) => {
  const { value: equiments, getData: refequiments } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "equiments_equipments"
  );

  const [api, contextHolder] = notification.useNotification();
  const [createNew, setCreateNew] = useState({
    date: "",
    to: "",
    cc: "",
    subject: "",
  });
  useEffect(() => {
    data &&
      setCreateNew({
        date: data.date,
        to: data.to,
        cc: data.cc,
        subject: data.subject,
      });
  }, [data]);
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // name:yup.string().required("Name is Requried")
    }),
    onSubmit: (value, { resetForm }) => {
      axiosInstance
        .post("/Equipments/", value)
        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.data.status == true) {
            getData();
            resetForm();
            api.success({
              message: `Description Creation successfully`,
              description: res?.data?.msg || "Added In The Description",
              placement: "bottomRight",
            });
            onCancel();
          } else {
            api.error({
              message: `Description Creation failed`,
              description: res?.data?.msg || "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Description Creation failed`,
            description: err?.data?.msg || "Sever error (or) Network error",
            placement: "bottomRight",
          });
        });
    },
  });
  const dummycc = [
    { value: 1, label: "bob.builder@example.com" },
    { value: 2, label: "samuel.lang@example.com" },
    { value: 3, label: "jeff.bezos@example.com" },
    { value: 4, label: "john.doe@example.com" },
    { value: 5, label: "jane.smith@example.com" },
  ];
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState([]);
  const toast = useToast();

    function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = [];

    files.forEach((item) => {
      if (item.size < maxFileSize) {  
        fileArr.push(item);
      } else {
        toast.open({
          type: "warning",
          message: `File Size too big`,
          description: `${item.name} is removed and not uploaded`,
        });
      }
    });

    setSelectedFile(fileArr);


    setImage(fileArr);
    e.target.value = null;
  }

  const removeImages = (value) => {
    let List = selectedFile.filter((item) => item?.name !== value?.name);
    setSelectedFile([...List]);
    setImage(List);
  };
  return (
    <>
      {contextHolder}
      <Modal
        open={open}
        title={data ? "Edit Email" : "Create Email"}
        width={"50%"}
        className="my-modal"
        centered
        onCancel={onCancel}
        footer={null} // Ensuring no default footer
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full flex flex-wrap">
            <NuDate
              label="Date"
              placeholder="Date"
              formik={formik}
              name="date"
              width="w-full"
            />

            <NuInput
              label="To"
              placeholder="To"
              formik={formik}
              name="to"
              width="w-full"
              new_width="w-full"
            />

            <DropDownAddMetaData
              label="CC"
              placeholder="Choose"
              Options={dummycc}
              formik={formik}
              name="cc"
              width="w-full"
              displayProperty="cc"
              propertyName="cc_Email"
              FixPosition={false}
              PortalTarget={false}
            />

            <NuTextArea
              label="Subject"
              placeholder="Subject"
              formik={formik}
              name="subject"
              width="w-full"
              new_width="w-full"
            />

            <Attachement
              handleChange={handleImageChange}
              preview={image || ""}
              width="w-full"
              label="Attach"
              multiple={true}
              removeImages={removeImages}
            />

            <div className="flex w-full justify-end gap-4 mt-4">
              <button
                type="button"
                className="w-20 bg-gray-400 py-2 rounded-lg cursor-pointer text-sm outline-none border-none hover:bg-gray-500 text-white"
                onClick={onCancel}
              >
                Close
              </button>
              <button
                type="submit"
                className="w-20 bg-blue-600 py-2 rounded-lg cursor-pointer text-sm outline-none border-none hover:bg-blue-700 text-white"
              >
                Submit
              </button>
              <button
                type="submit"
                className="w-20 border border-blue-600 bg-blue-400 py-2 rounded-lg text-white cursor-pointer text-sm outline-none hover:bg-blue-700"
              >
                Send
              </button>
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default CreateEmailSent;
